import defs from '../../_core/defs.js';
import forEach from '../../_helpers/foreach.js';
import removeNode from '../../_helpers/removenode.js';
// this function removes DOM nodes of removed items
// called on splice, pull, pop and shift
export default function processRemove(_ref) {
  var selfDef = _ref.selfDef,
    eventOptions = _ref.eventOptions;
  var removed = eventOptions.removed,
    added = eventOptions.added;
  var selfId = selfDef.id;
  forEach(removed, function (item) {
    // a splice that puts an item back keeps its node
    if (item && typeof item === 'object' && !(added && added.indexOf(item) !== -1)) {
      var itemDef = defs.get(item);
      if (itemDef) {
        var renderedInArrays = itemDef.renderedInArrays;
        var node = renderedInArrays == null ? void 0 : renderedInArrays[selfId];
        if (renderedInArrays && node) {
          delete renderedInArrays[selfId];
          // the node may be out of the current container (e.g. the container was rebound)
          // or replaced by a placeholder (the existence binder)
          removeNode(node.__replacedByNode);
          removeNode(node);
        }
      }
    }
  });
}